export const categoryTypes = {
    'en': [{
        title: 'Any',
        value: 'all'
    },
    {
        title: 'Villa/Townhouse',
        value: 'house'
    },
    {
        title: 'Land',
        value: 'land'
    },
    {
        title: 'Condo',
        value: 'condo'
    },
    {
        title: 'Commercial',
        value: 'commercial'
    }],
    'th': [{
        title: 'ประเภท',
        value: 'all'
    },
    {
        title: 'วิลล่า/ทาวน์เฮาส์',
        value: 'house'
    },
    {
        title: 'ที่ดิน',
        value: 'land'
    },
    {
        title: 'คอนโด',
        value: 'condo'
    },
    {
        title: 'เชิงพาณิชย์',
        value: 'commercial'
    }],     
    'cn': [{
        title: '不限',
        value: 'all'
    },
    {
        title: '别墅/联排别墅',
        value: 'house'
    },
    {
        title: '土地',
        value: 'land'
    },
    {
        title: '公寓',
        value: 'condo'
    },
    {
        title: '工商',
        value: 'commercial'
    }],
    'ru': [{
        title: 'Любой',
        value: 'all'
    },
    {
        title: 'Вилла/Таунхаус',
        value: 'house'
    },
    {
        title: 'Земля',
        value: 'land'
    },
    {
        title: 'Квартира',
        value: 'condo'
    },
    {
        title: 'Коммерческая',
        value: 'commercial'
    }],
    'de': [{
        title: 'Beliebig',
        value: 'all'
    },
    {
        title: 'Villa/Stadthaus',
        value: 'house'
    },
    {
        title: 'Grundstück',
        value: 'land'
    },
    {
        title: 'Eigentumswohnung',
        value: 'condo'
    },
    {
        title: 'Gewerbeimmobilie',
        value: 'commercial'
    }],
    'fr': [{
        title: 'N\'importe quel',
        value: 'all'
    },
    {
        title: 'Villa/Maison de ville',
        value: 'house'
    },
    {
        title: 'Terrain',
        value: 'land'
    },
    {
        title: 'Appartement',
        value: 'condo'
    },
    {
        title: 'Commercial',
        value: 'commercial'
    }]
}